<template>
  <b-container class="page-container">
    <bread-crumbs
      :bread-crumbs="[
        { title: $t('general.bikeRental'), path: '/' },
        { title: $t('myaccount'), path: '/account' }
      ]"
      :currentpage="$t('account-addNewSub')"
    />
    <b-form @submit.prevent="createNewSub">
      <h1 class="text-center">{{ $t('account-addNewSub') }}</h1>

      <b-row>
        <b-col sm="12" lg="8">
          <b-card>
            <h4>{{ $t('account-detailsOfNewPerson') }}</h4>

            <b-row>
              <b-col cols="6" class="pb-3">
                <label>
                  {{ $t('firstname') }}
                  <span class="text-danger">*</span>
                </label>
                <b-form-input v-model="form.firstname" required></b-form-input>
              </b-col>
              <b-col cols="6" class="pb-3">
                <label>
                  {{ $t('lastname') }}
                  <span class="text-danger">*</span>
                </label>
                <b-form-input v-model="form.lastname" required></b-form-input>
              </b-col>

              <b-col sm="12" md="6">
                <b-form-group id="input-group-tel" label-for="input-tel">
                  <label>
                    {{ $t('gsm') }}
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    id="input-tel"
                    v-model="form.CONTACT_MobilePhone"
                    type="text"
                    name="mobiletel"
                    required
                    oninput="javascript: this.value = this.value.replace(/[A-Za-z]/gi, '');"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <label>
                  {{ $t('telephoneNumber') }}
                  <span class="text-danger"></span>
                </label>
                <b-form-input
                  v-model="form.tel"
                  oninput="javascript: this.value = this.value.replace(/[A-Za-z]/gi, '');"
                ></b-form-input>
              </b-col>
              <b-col xs="12" md="12" class="pb-3">
                <label>
                  {{ $t('emailaddress') }}
                  <span class="text-danger">*</span>
                </label>
                <b-form-input v-model="form.email" required></b-form-input>
              </b-col>
              <b-col cols="12">
                <hr />
                <password-helper-block />
              </b-col>
              <b-col
                v-if="!passwordValidation && form.password.length > 0"
                cols="12"
                class="pb-3"
              >
                <span class="text-danger">{{
                  $t('password-not-complying')
                }}</span>
              </b-col>
              <b-col cols="6" class="pb-3">
                <label>
                  {{ $t('password') }}
                  <span class="text-danger">*</span>
                </label>
                <b-input-group>
                  <b-form-input
                    v-model="form.password"
                    :state="passwordValidation"
                    :type="showPassword ? 'text' : 'password'"
                    required
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :title="$t('showPassword')"
                      @click="showPasswordToggle()"
                      variant="primary"
                    >
                      <icon-eye v-if="!showPassword" />
                      <icon-eye-slash v-if="showPassword" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="6">
                <label>
                  {{ $t('formFields.repeatPassword') }}
                  <span class="text-danger">*</span>
                </label>
                <b-input-group>
                  <b-form-input
                    v-model="form.confirmPassword"
                    :type="showPassword ? 'text' : 'password'"
                    :state="passwordConfirmState"
                    required
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :title="$t('formFields.showPassword')"
                      @click="showPasswordToggle()"
                      variant="primary"
                    >
                      <icon-eye v-if="!showPassword" />

                      <icon-eye-slash v-if="showPassword" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <div class="mt-5">
            <b-alert v-if="error" show variant="danger">{{
              errorMessage
            }}</b-alert>
          </div>
          <b-card class="mt-5">
            <b-row>
              <b-col>
                <h2 class="pt-2">{{ $t('confirm') }}?</h2>
              </b-col>
              <b-col class="text-right">
                <b-button variant="primary" type="submit">
                  {{ $t('account-createSub') }}

                  <icon-spinner v-if="processing" />
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { newSub } from '@/services/AuthorizationService'
import PasswordHelperBlock from '@/components/global/PasswordHelperBlock.vue'
import IconEye from '@/components/icons/IconEye'
import IconEyeSlash from '@/components/icons/IconEyeSlash'
import IconSpinner from '@/components/icons/IconSpinner'

export default {
  components: {
    IconSpinner,
    IconEyeSlash,
    IconEye,
    PasswordHelperBlock
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        tel: '',
        firstname: '',
        lastname: '',
        CONTACT_MobilePhone: ''
      },
      registering: false,
      formFilled: false,
      processing: false,
      error: null,
      showPassword: false
    }
  },
  computed: {
    passwordConfirmState() {
      if (this.form.password != '' && this.form.password != null) {
        if (this.form.password == this.form.confirmPassword) {
          return true
        }
        return false
      }
      return null
    },
    passwordValidation() {
      let password = this.form.password
      if (password != '') {
        if (password.length < 8) {
          return false
        }

        if (!password.match(/[!@$%&\-+*()&^]/)) return false
        if (!password.match(/[0-9]/)) return false
        if (!password.match(/[a-z]/)) return false
        if (!password.match(/[A-Z]/)) return false
        if (!/^([0-9a-zA-Z!@$%&\-+*()&^]*)$/.exec(password)) return false

        return true
      }

      return null
    }
  },
  methods: {
    showPasswordToggle: function() {
      if (this.showPassword) {
        this.showPassword = false
      } else {
        this.showPassword = true
      }
    },
    createNewSub: async function() {
      this.processing = true

      if (!this.passwordValidation) {
        this.processing = false
        this.incorrectPassword = true
        return
      }
      if (this.form.password == this.form.confirmPassword) {
        const result = await newSub({
          email: this.form.email,
          password: this.form.password,
          confirmPassword: this.form.confirmPassword,
          tel: this.form.tel,
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          CONTACT_MobilePhone: this.form.CONTACT_MobilePhone
        })

        if (result.data.Message === 'MaxUserCountHasBeenReached') {
          this.errorMessage = this.$t('maxSubUserReached')

          this.error = true
          this.processing = false
          return
        }

        if (
          result.data.Message === 'The entered e-mail address is unauthorized.'
        ) {
          this.errorMessage = this.$t('subAlreadyExists')
          this.error = true
          this.processing = false
          return
        }

        this.$router.push({
          name: 'account',
          query: { message: this.$t('newSubSuccesfullyCreated') }
        })
      } else {
        this.processing = false
      }
    }
  }
}
</script>

<style></style>
